import { SizeClass, useSizeClass } from '@omni/kit/contexts/SizeClassContext';
import Colors from '@omni/kit/theming/Colors';
import { createStackNavigator } from '@react-navigation/stack';
import React, { ReactElement } from 'react';
import { Platform } from 'react-native';
import { createNativeStackNavigator } from 'react-native-screens/native-stack';

import {
  BIBLE_LOCATION_SCREEN,
  BIBLE_VERSE_SCREEN,
} from '../../shared/Constants';
import navStyles from '../navigation/navStyles';
import BibleLocationScreen from '../screens/BibleLocationScreen';
import BibleVerseScreen from '../screens/BibleVerseScreen';
import LeftNavButton, { LeftNavType } from './LeftNavButton';

const Stack =
  Platform.OS === 'web' ? createStackNavigator() : createNativeStackNavigator();

export const BibleSelectionModalWithHeader = ({
  togglePopup = () => null,
}: {
  togglePopup?: () => void;
}): ReactElement => {
  const { sizeClass } = useSizeClass();

  return (
    <Stack.Navigator
      screenOptions={{
        // @ts-ignore
        headerHideShadow: true,
        headerShown: sizeClass !== SizeClass.Large,
        headerTitleStyle: navStyles.headerTitleStyle,
      }}
    >
      <Stack.Screen
        name={BIBLE_LOCATION_SCREEN}
        component={BibleLocationScreen}
        options={(props: { navigation: { goBack: () => void } }) => ({
          title: 'Choose a passage',
          headerTintColor: Colors.N900,
          headerLeft: () => (
            <LeftNavButton
              type={LeftNavType.Dismiss}
              title='Choose a passage'
              onPress={props.navigation.goBack}
            />
          ),
        })}
      />
      <Stack.Screen
        name={BIBLE_VERSE_SCREEN}
        options={(props: { navigation: { goBack: () => void } }) => ({
          title: 'Choose verses',
          headerTintColor: Colors.N900,
          headerLeft: () => (
            <LeftNavButton
              type={LeftNavType.Back}
              title='Choose verses'
              onPress={props.navigation.goBack}
            />
          ),
        })}
      >
        {/* @ts-ignore */}
        {() => <BibleVerseScreen togglePopup={togglePopup} />}
      </Stack.Screen>
    </Stack.Navigator>
  );
};
